export const SITE_URL = "https://wwcollision.com";
export const BIZ = {
  name: "Westway Collision Center",
  phoneDisplay: "(214) 888-2886",
  phoneHref: "tel:+12148882886",
  email: "hello@wwcollision.com",
  street: "1420 Westway Cir",
  city: "Carrollton",
  state: "TX",
  zip: "75006",
  addressLine: "1420 Westway Cir, Carrollton, TX 75006",
  hoursShort: "Mon–Fri 7:30 AM–6:00 PM · Sat 8:00 AM–5:00 PM · Sun Closed",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=1420+Westway+Cir+Carrollton+TX+75006",
};

export const LAST_UPDATED = "July 2, 2026";
export const LAST_UPDATED_ISO = "2026-07-02";

export const CITIES = [
  { slug: "carrollton", name: "Carrollton" },
  { slug: "farmers-branch", name: "Farmers Branch" },
  { slug: "addison", name: "Addison" },
  { slug: "coppell", name: "Coppell" },
  { slug: "dallas", name: "Dallas" },
  { slug: "lewisville", name: "Lewisville" },
  { slug: "plano", name: "Plano" },
  { slug: "irving", name: "Irving" },
];

export const TRUST_ITEMS = [
  "I-CAR Gold Class",
  "Lifetime Warranty",
  "All Major Insurance",
  "Free Estimates",
  "Free Tow",
];

// Paste your GA4 Measurement ID (G-XXXXXXX) and Google Ads tag into
// public/index.html where marked. Once present, these events fire automatically.
export const track = (event, params = {}) => {
  if (typeof window === "undefined") return;
  if (window.gtag) window.gtag("event", event, params);
  if (window.dataLayer) window.dataLayer.push({ event, ...params });
};

export const GOOGLE_RATING = "4.9";
export const GOOGLE_REVIEW_COUNT = "490+";
export const GOOGLE_REVIEWS_URL = "https://maps.app.goo.gl/KLK11TJFdLCAtePM7";

// Strips [PLACEHOLDER: ...] segments so internal notes never render publicly.
export const cleanText = (t) =>
  typeof t === "string" ? t.replace(/\s*\[PLACEHOLDER[^\]]*\]/g, "").replace(/\s+([;,])/g, "$1").trim() : t;

export const scrollToEl = (e, selector) => {
  e.preventDefault();
  const el = document.querySelector(selector);
  if (!el) return;
  if (window.lenis) window.lenis.scrollTo(el, { offset: -70, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
